import _extends from "@babel/runtime/helpers/esm/extends";
import { useAxiosClient } from '../hooks';
import { createQueryKey, sanitizeParams } from '../utils';
import useQuery from './useQuery';
export default function useCountFromContentRange(variant, basePath, params, options) {
  const axiosClient = useAxiosClient();
  const paramsSanitized = sanitizeParams(_extends({
    _select: '_id',
    limit: 1
  }, params));
  async function queryFn() {
    var _response$headers;
    const url = variant.replace('{basePath}', basePath);
    const response = await axiosClient.get(url, {
      params: paramsSanitized,
      headers: {
        'content-range': '0-0'
      }
    });
    const contentRange = (((_response$headers = response.headers) == null ? void 0 : _response$headers['content-range']) || '').split('/');
    const totalCount = parseInt(contentRange[1], 10);
    return totalCount;
  }
  const queryKey = createQueryKey(basePath, variant, paramsSanitized);
  return useQuery(queryKey, queryFn, options);
}